import { call, put, takeEvery } from "redux-saga/effects"
import _ from 'lodash';

// Crypto Redux States
import { GET_COUPONS , ADD_NEW_COUPON , UPDATE_COUPON } from "./actionTypes"

import {
  getCouponsSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { API_ENDPOINTS } from "api/endpoints"
import { Toast } from "helpers/Toast"


function* fetchCoupons(data) {
  try {
    const response = yield call(API_ENDPOINTS.getTubPacks, {queryStringParameters: data.payload})
    yield put(getCouponsSuccess(response))
  } catch (error) {
    Toast('error', error)
  }
}


function* onAddNewCoupon(data) {
  try {
    let res = yield call(API_ENDPOINTS.createOrEditCoupon, {body: data.payload})
  } catch (error) {
    Toast('error', error)
  }
}

function* updateCouponDetail(data) {
  try {
    let body = {
      body: data.payload,
      queryStringParameters: {
        imageId: data.payload._id
      }
    }
    yield call(API_ENDPOINTS.createOrEditCoupon, body)

  } catch (error) {
    console.log('error', error)
    Toast('error', error)
  }
}


function* wordsSaga() {
  yield takeEvery(GET_COUPONS, fetchCoupons)
  yield takeEvery(ADD_NEW_COUPON, onAddNewCoupon)
  yield takeEvery(UPDATE_COUPON, updateCouponDetail)
}

export default wordsSaga;
